module.exports = __webpack_public_path__ + "img/modelo-eg2.d8c51b2d.png";